import { FormRow } from "../../components/FormRow";
import { Toggle } from "../../components/Toggle";
import type { Field } from "../types";

interface Props {
  field: Field;
  value: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
}

export function BoolField({ field, value, onChange, disabled }: Props) {
  return (
    <FormRow label={field.title ?? field.key} help={field.help}>
      <Toggle checked={value} onChange={onChange} disabled={disabled} />
    </FormRow>
  );
}
